/**
 * The round-index fetcher over the typed client (issue #334): a conditional
 * GET when an ETag is known. The client's middleware lets a `304` through (it
 * is the expected answer to our own `If-None-Match`, not an error), so it is
 * read here from `response.status`; any real failure still throws `ApiError`.
 */

import { api, type ApiClient } from "../../api/client";
import type { IndexFetchResult } from "./indexSync";

export async function fetchRoundIndex(
  roundId: string,
  ifNoneMatch: string | null,
  client: ApiClient = api,
): Promise<IndexFetchResult> {
  const res = await client.GET("/rounds/{round_id}/expediente-index", {
    params: {
      path: { round_id: roundId },
      header: ifNoneMatch ? { "If-None-Match": ifNoneMatch } : undefined,
    },
  });
  if (res.response.status === 304) return { status: "not-modified" };
  return {
    status: "ok",
    // Cross-origin (local dev) the header is only readable when the API
    // exposes it; without it every probe is a full 200 — correct, just heavier.
    etag: res.response.headers.get("ETag"),
    items: res.data!.items,
  };
}
